import { ACTION } from '@/store/ACTION';

class SetPromoAppConfig {
  protected allowed(): boolean {
    return this.store.promo.hasPromoApp();
  }

  execution(config: any): void {
    if (!this.allowed()) return;

    promoApp.eventEmitter.emit(ACTION.SET_APP_CONFIGURATION, {
      uiSize: config?.uiSize,
      isMobile: game.env.isMobileDevice(),
      lang: initConfig.lang || 'en',
      platformName: this.store.platform.name,
      uiPosition: config?.uiPosition,
      currentGid: initConfig.gameIdentificationNumber,
      settings: config?.settings
    });
  }

  get store() {
    return game.store;
  }
}

export { SetPromoAppConfig };
